import React from 'react'
import { Jumbotron, Button, Col, Row } from 'reactstrap'
import './header.css'
import { Link } from 'react-scroll'
import NavBar from './navbar'

var Translate = require('react-translate-component')
export default class Header extends React.Component {
  render () {
    return (
      <Jumbotron id='jumbotronHeader'>
         <NavBar />
        <div className='headerContent'>
          <p className='text'>
            <Translate content='postaw_na' />
          </p>
          <p className='text'>
            <Translate content='profesjonalistow' />
          </p>
          <p className='headerText'>
            <Translate content='wspolpracujemy_z' />
          </p>
          <Row>
            <Col md="3" xs="12" sm="12">
              <Button className='headerButton' id='offerBtn' size='lg'>
                <Link
                  activeClass='active'
                  to='offers'
                  spy={true}
                  smooth={true}
                  duration={500}
                  offset={-89}
                >
                  <Translate content='sprawdz_oferte' />
                </Link>
              </Button>
            </Col>
          </Row>
        </div>
      </Jumbotron>
    )
  }
}
